'use client';
import { Flex } from '@chakra-ui/react';
import { memo, useCallback, useEffect, useRef, useState } from 'react';

import { SwitcherComponent } from './ui';
import { throttle } from 'shared/lib';

const Switcher = ({ uniqueId, boxProps = null, ...props }) => {
  const boxRef = useRef(null);
  const shadowSwitcherRef = useRef(null);
  const [isCompactDesign, setIsCompactDesign] = useState(false);

  const handleResize = useCallback(() => {
    const box = boxRef.current;
    const shadowSwitcher = shadowSwitcherRef.current;

    if (box && shadowSwitcher) setIsCompactDesign(box.clientWidth < shadowSwitcher.clientWidth);
  }, []);
  const throttledHandleResize = throttle(handleResize, 300);

  useEffect(() => {
    window.addEventListener('resize', throttledHandleResize);
    handleResize();

    return () => window.removeEventListener('resize', throttledHandleResize);
  }, [handleResize, throttledHandleResize]);

  return (
    <Flex
      ref={boxRef}
      pos="relative"
      w={isCompactDesign && 'full'}
      maxW="full"
      overflow="hidden"
      {...boxProps}
    >
      <SwitcherComponent
        {...props}
        ref={shadowSwitcherRef}
        uniqueId={uniqueId}
        pos="absolute"
        opacity="0.001"
        pointerEvents="none"
        w="max-content"
      />

      <SwitcherComponent {...props} isCompactDesign={isCompactDesign} uniqueId={uniqueId} />
    </Flex>
  );
};

export default memo(Switcher);
